import React from 'react';

import ErrorMessage from '../../../../design-system/ErrorMessage/ErrorMessage';
import RequirementContentItem from '../RequirementContentItem/RequirementContentItem';

const RequirementsContentSection = ({ groupFormData, setGroupFormData, isEditable }) => {
    if (!groupFormData || groupFormData.length === 0) return null;

    return (
        <div className="w-full flex flex-col gap-2.5">
            {groupFormData.map((requirement) => {
                const { label, order, content, name, state } = requirement;

                const setContentItem = (itemName, cb) => {
                    if (!isEditable) return;

                    setGroupFormData((prev) =>
                        prev.map((section) => {
                            if (section.name !== name) return section;

                            const { content, ...restSection } = section;

                            const updatedContent = content?.map((item) => {
                                if (item.name !== itemName) return item;
                                return typeof cb === 'function' ? cb(item) : cb;
                            });

                            return { ...restSection, content: updatedContent, state: 'default' };
                        })
                    );
                };

                return (
                    <div key={order + name} className="flex flex-col gap-4">
                        <p className="font-body-bold text-body-bold-s text-neutral-500">{label}</p>

                        {!!content?.length && (
                            <div className="flex flex-col w-full">
                                {content?.map((item) => (
                                    <RequirementContentItem
                                        key={item.order + item.name}
                                        item={item}
                                        setContentItem={(cb) => setContentItem(item.name, cb)}
                                        isEditable={isEditable}
                                    />
                                ))}
                            </div>
                        )}

                        {state === 'error' && (
                            <ErrorMessage
                                message="Please answer all required questions and ensure at least one requirement is selected."
                                customStyles="-mt-3"
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default RequirementsContentSection;
